import * as angular from 'angular';

import { ComponentDefinition, Dictionary, IdentifierWithAlarms, IValueViewModel } from '../../models';
import { refreshClick, getUnitName } from '../../common/';

class AlarmsDisabledTableController implements angular.IComponentController {
    alarms: Dictionary<IdentifierWithAlarms>;
    count: number = 0;
    hasGroupName: boolean = false;
    isLoading: boolean;
    loadingMessage: string;

    readonly alarmList: Dictionary<IdentifierWithAlarms>;
    readonly identifiers: IValueViewModel[];
    readonly isEditMode: boolean = false;

    private _garbages: (() => void)[] = [];

    static $inject = [
        '$scope'
    ];

    constructor(
        private _$scope: angular.IScope
    ) {
    }

    $onInit() {
        this._$scope.$on(refreshClick, () => this.refresh());
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['alarmList']) {
            const alarmList = changesObj['alarmList'].currentValue;
            if (alarmList) {
                this.refresh();
            }
        }
    }

    $onDestroy() {
        this._garbages.forEach(w => w());
    }

    private fillIdentifiersInAlarms(alarmList: Dictionary<IdentifierWithAlarms>): void {
        if (alarmList) {
            this.alarms = alarmList;
            Object.keys(alarmList).forEach(key => {
                this.alarms[key].alarms.forEach(alarm => {
                    alarm.unitName = getUnitName(this.alarms[key].identifier.unitName, alarm.value);
                });
            });
            this.count = Object.keys(alarmList).length;
        }
    }

    private refresh() {
        this.isLoading = true;
        this.fillIdentifiersInAlarms(this.alarmList);
        this.isLoading = false;
    }
}

export const wtAlarmsDisabledTable: ComponentDefinition = {
    componentId: 'wtAlarmsDisabledTable',
    controller: AlarmsDisabledTableController,
    template: require('./alarmsDisabledTable.component.html'),
    controllerAs: 'vm',
    bindings: {
        alarmList: '<',
        identifiers: '<',
        isEditMode: '<',
        item: '='
    }
};